// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function rangesStrictOverlap(startA, endA, startB, endB) {
  return Math.max(startA, startB) < Math.min(endA, endB);
}

function reconcile(text, rows) {
  var n = rows.length;
  if (n === 0) {
    return [];
  }
  var textLength = text.length;
  var order = Belt_Array.makeBy(n, (function (i) {
          return i;
        }));
  order.sort(function (ia, ib) {
        var a = rows[ia];
        var b = rows[ib];
        var delta = a.start - b.start;
        if (delta < 0.0) {
          return -1;
        } else if (delta > 0.0) {
          return 1;
        } else {
          return 0;
        }
      });
  var out = Belt_Array.makeBy(n, (function (param) {
          return {
                  start: 0.0,
                  end: 0.0
                };
        }));
  var minSearch = {
    contents: 0.0
  };
  order.forEach(function (j) {
        var row = rows[j];
        var needleLength = row.needle.length;
        var start = row.start;
        var end_ = row.end;
        var offsetsValid = Number.isFinite(start) && Number.isFinite(end_) && end_ > start && start >= 0.0 && end_ <= textLength;
        var sliceMatches = offsetsValid && needleLength > 0 && text.slice(start | 0, end_ | 0) === row.needle;
        if (!sliceMatches && needleLength > 0) {
          var idx = text.indexOf(row.needle, minSearch.contents | 0);
          if (idx !== -1) {
            start = idx;
            end_ = idx + needleLength | 0;
          }
          
        }
        minSearch.contents = Math.max(minSearch.contents, end_);
        out[j] = {
          start: start,
          end: end_
        };
      });
  return out;
}

function overlapsAny(ranges, start, end_) {
  return ranges.some(function (range) {
              if (!Number.isFinite(range.start) || !Number.isFinite(range.end) || range.end <= range.start) {
                return false;
              } else {
                return rangesStrictOverlap(start, end_, range.start, range.end);
              }
            });
}

function renderOrder(pairs) {
  return pairs.filter(function (pair) {
                return pair.end > pair.start;
              }).sort(function (a, b) {
              var delta = b.start - a.start;
              if (delta < 0.0) {
                return -1;
              } else if (delta > 0.0) {
                return 1;
              } else {
                return 0;
              }
            });
}

export {
  rangesStrictOverlap ,
  reconcile ,
  overlapsAny ,
  renderOrder ,
}
/* No side effect */
